import styled from 'styled-components';

export const ClickToCallStyles = styled.div`
  .clicktocall {
    position: fixed;
    bottom: 220px;
    right: -1px;
    z-index: 1189;
    background-color: white;
    background-repeat: no-repeat;
    background-size: 24px;
    background-position: center;
    color: red;
    border-radius: 50% 0 0 50%;
    height: 50px;
    width: 50px;
    padding: 0;
    -webkit-box-shadow: 0 0 15px 0 rgb(111 127 134 / 40%);
    box-shadow: 0 0 15px 0 rgb(111 127 134 / 40%);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 24px;
      height: 24px;
      pointer-events: none;
    }
  }

  @media (max-width: 520px) {
    .clicktocall {
      position: fixed;
      bottom: 220px;
      right: -2pxpx;
      z-index: 1189;
    }
  }
`;
